import { TextField } from '@material-ui/core';
import { Box, Button, MenuItem, Select, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { FixedOdds } from '../../types/fixedOdds';
import { AddTicketsData } from '../../types/order';
import { filtrByEndsAt } from '../../helpers/filtrByEndsAt';
import './index.css';
import moment from 'moment';

let competitions = [
  'Dream home',
  'Weekly Subscription Draw',
  'Lifestyle Prizes',
  'Fixed Odds',
];

const getCompetitionName = (name: string): string => {
  switch (name) {
    case 'Dream home':
      return 'raffle';
    case 'Lifestyle Prizes':
      return 'prize';
    case 'Fixed Odds':
      return 'fixedOdds';
    case 'Weekly Subscription Draw':
      return 'weeklySubscriptionDraw';
    default:
      return 'raffle';
  }
};

interface Products {
  id: string;
  title: string;
  active?: boolean;
  isClosed?: boolean;
}

interface SelectCategories {
  id: string;
  title: string;
  _id?: string;
}

interface Props {
  closeModal: () => void;
  id: string;
}

const AddTickets: FC<Props> = ({ closeModal, id }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  useEffect(() => {
    getProducts('Dream home');
  }, []);

  const [products, setProducts] = useState(Array<Products>());
  const [weeklySubscriptionDraws, setWeeklySubscriptionDraws] = useState(
    Array<any>()
  );
  const [categories, setCategories] = useState({
    selectedCategory: { id: '', title: '' },
    selectedSubCategory: { id: '', title: '' },
    category: Array<SelectCategories>(),
    subCategory: Array<SelectCategories>(),
  });

  const [disabledSaveButton, setDisabledSaveButton] = useState(false);

  const [fixedOdds, setFixedOdds] = useState({
    fixedOdds: Array<FixedOdds>(),
    maxValue: 0,
  });

  const [selectedValue, setSelectedValue] = useState({
    competition: '',
    selectedProduct: { id: '', title: '' },
    selectedWeeklySubscriptionProduct: { id: '', title: '', prizeId: '' },
    ticketsCount: 1,
    showCategory: false,
    showWeeklySubscriptionDraws: false,
  });

  const getProducts = async (competition: string) => {
    let products = Array<Products>();
    let weeklySubscriptionDraws = Array<any>();
    let product = { id: '', title: '' };
    let weeklySubscriptionProduct = { id: '', title: '', prizeId: '' };
    if (competition === 'Dream home') {
      // products = await getDreamHome();
      products = await getDreamHomeLast();
      if (products.length > 0) {
        product = { title: products[0].title, id: products[0].id };
      } else {
        competitions.shift();
        products = await getFixedOdds();
        const selectedProduct = {
          title: products[0].title,
          id: products[0].id,
        };
      }
    }
    if (competition === 'Weekly Subscription Draw') {
      // products = await getDreamHome();
      weeklySubscriptionDraws = await getWeeklySubscriptionDraws();
      if (weeklySubscriptionDraws.length > 0) {
        weeklySubscriptionProduct = {
          title:
            weeklySubscriptionDraws[weeklySubscriptionDraws.length - 1]
              .weeklySubscriptionDraw.title,
          id: weeklySubscriptionDraws[weeklySubscriptionDraws.length - 1].id,
          prizeId:
            weeklySubscriptionDraws[weeklySubscriptionDraws.length - 1]
              .weeklySubscriptionDraw._id,
        };
      }
      products = await getDreamHomeLast();
      if (products.length > 0) {
        product = { title: products[0].title, id: products[0].id };
      } else {
        competitions.shift();
        products = await getFixedOdds();
        const selectedProduct = {
          title: products[0].title,
          id: products[0].id,
        };
      }
    }
    setProducts(products);
    setWeeklySubscriptionDraws(weeklySubscriptionDraws);
    setSelectedValue({
      ...selectedValue,
      competition: 'Dream home',
      selectedProduct: product,
      selectedWeeklySubscriptionProduct: weeklySubscriptionProduct,
    });
  };

  const getDreamHome = async () => {
    const result = (await dataProvider.getDreamhomeList('raffles/active/cms', {
      filter: {},
      pagination: { page: 1, perPage: 10 },
      sort: { field: 'id', order: 'ASC' },
    })) as any;
    return result.data;
  };

  const getDreamHomeLast = async () => {
    const result = (await dataProvider.getDreamhomeList(
      'raffles/active/cms/last',
      {
        filter: {},
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'id', order: 'ASC' },
      }
    )) as any;
    return result.data;
  };
  const getWeeklySubscriptionDraws = async () => {
    const result = (await dataProvider.getWeeklySubscriptionDraws(
      'weeklySubscriptionDraws/active/cms/last',
      {
        filter: {},
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'id', order: 'ASC' },
      }
    )) as any;
    return result.data.filter((item) => item.weeklySubscriptionDraw);
  };

  const getPrizes = async (categoryId: string, subCategoryId?: string) => {
    const result = (await dataProvider.getPrizesForFilter({
      filter: {
        email: '',
        categoriesIds: [categoryId],
        subCategoriesIds: subCategoryId ? [subCategoryId] : [],
        prizesIds: [],
        status: true,
      },
      pagination: { page: 0, perPage: 0 },
      sort: { field: '', order: '' },
    })) as any;
    const prizes = result.data.map((item) => {
      item.name = item.title;
      return item;
    });
    return prizes;
  };

  const getFixedOdds = async () => {
    let maxTickets = 0;
    const result = (await dataProvider.getList('fixedOdds', {
      filter: { status: 'Active', discount: 'all', ids: [], titles: [] },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: '_id', order: 'asc' },
    })) as any;
    const fixedOdds = result.data
      .map((item, i) => {
        if (i === 0) {
          maxTickets = item.maxTickets - item.ticketsBought;
        }
        item.name = item.title;
        return item;
      })
      .filter(filtrByEndsAt);
    setFixedOdds({
      ...fixedOdds,
      fixedOdds: result.data,
      maxValue: maxTickets,
    });
    return fixedOdds;
  };

  const getCategories = async () => {
    const categories = (await dataProvider.getDreamhomeList(
      'prizeCategories/order',
      {
        filter: { email: '', isActive: 'with' },
        pagination: { page: 0, perPage: 0 },
        sort: { field: 'id', order: 'asc' },
      }
    )) as any;
    return categories.data;
  };

  const getSubCategories = async (id: string) => {
    const subCategories = (await dataProvider.getOne(`subcategories`, {
      id: id,
    })) as any;
    return subCategories.data.subcategories;
  };

  const handleChange = async (event) => {
    let isLifestyle = false;
    let isWeeklySubscriptionDraw = false;
    let products = Array<Products>();
    let weeklySubscriptionDraws = Array<any>();
    let selectedProduct = { id: '', title: '' };
    let weeklySubscriptionSelectedProduct = {
      prizeId: '',
      id: '',
      title: '',
    };
    if (
      event.target.name === 'competition' &&
      event.target.value === 'Lifestyle Prizes'
    ) {
      isLifestyle = true;
      const categoryResult = await getCategories();
      let subCategoryResult = await getSubCategories(categoryResult[0].id);
      const subcategoryId =
        subCategoryResult.length === 0 ? undefined : subCategoryResult[0]._id;
      products = await getPrizes(categoryResult[0].id, subcategoryId);
      selectedProduct = { id: products[0].id, title: products[0].title };
      setCategories({
        ...categories,
        category: categoryResult,
        selectedCategory: {
          title: categoryResult[0].title,
          id: categoryResult[0].id,
        },
        selectedSubCategory:
          subCategoryResult.length === 0
            ? { id: '', title: '' }
            : {
                title: subCategoryResult[0].title,
                id: subCategoryResult[0]._id,
              },
        subCategory: subCategoryResult,
      });
    }
    if (
      event.target.name === 'competition' &&
      event.target.value === 'Dream home'
    ) {
      products = await getDreamHomeLast();
      if (products.length > 0) {
        selectedProduct = {
          title: products[0].title || '',
          id: products[0].id,
        };
      } else {
        return;
      }
    }
    if (
      event.target.name === 'competition' &&
      event.target.value === 'Weekly Subscription Draw'
    ) {
      isWeeklySubscriptionDraw = true;

      weeklySubscriptionDraws = await getWeeklySubscriptionDraws();
      if (weeklySubscriptionDraws.length > 0) {
        weeklySubscriptionSelectedProduct = {
          title:
            weeklySubscriptionDraws[weeklySubscriptionDraws.length - 1]
              .weeklySubscriptionDraw.title || '',
          id: weeklySubscriptionDraws[weeklySubscriptionDraws.length - 1].id,
          prizeId:
            weeklySubscriptionDraws[weeklySubscriptionDraws.length - 1]
              .weeklySubscriptionDraw._id,
        };
      }
      products = await getDreamHomeLast();
      if (products.length > 0) {
        selectedProduct = {
          title: products[0].title || '',
          id: products[0].id,
        };
      } else {
        return;
      }
    }
    if (
      event.target.name === 'competition' &&
      event.target.value === 'Fixed Odds'
    ) {
      products = await getFixedOdds();
      selectedProduct = { title: products[0].title || '', id: products[0].id };
    }
    setProducts(products);
    setWeeklySubscriptionDraws(weeklySubscriptionDraws);
    setSelectedValue({
      ...selectedValue,
      selectedProduct: selectedProduct,
      selectedWeeklySubscriptionProduct: weeklySubscriptionSelectedProduct,
      [event.target.name]: event.target.value,
      showCategory: isLifestyle,
      showWeeklySubscriptionDraws: isWeeklySubscriptionDraw,
    });
  };

  const handleCategoryChange = async (event) => {
    const sub = await getSubCategories(event.nativeEvent.target.id);
    const selectedSub =
      sub.length > 0
        ? { title: sub[0].title, id: sub[0]._id }
        : { title: '', id: '' };
    const products = await getPrizes(
      event.nativeEvent.target.id,
      selectedSub.id
    );
    setProducts(products);
    setSelectedValue({
      ...selectedValue,
      selectedProduct: { id: products[0].id, title: products[0].name },
    });
    setCategories({
      ...categories,
      selectedCategory: {
        title: event.target.value,
        id: event.nativeEvent.target.id,
      },
      subCategory: sub,
      selectedSubCategory: selectedSub,
    });
  };

  const handleSubCategoryChange = async (event) => {
    const selectedSub = {
      title: event.target.value,
      id: event.currentTarget.id,
    };
    const products = await getPrizes(
      categories.selectedCategory.id,
      selectedSub.id
    );
    setProducts(products);
    setSelectedValue({
      ...selectedValue,
      selectedProduct: { id: products[0].id, title: products[0].name },
    });
    setCategories({ ...categories, selectedSubCategory: selectedSub });
  };

  const handleProductChange = (event) => {
    if (selectedValue.competition === 'Fixed Odds') {
      fixedOdds.fixedOdds.map((item) => {
        if (item._id === event.nativeEvent.target.id) {
          setFixedOdds({
            ...fixedOdds,
            maxValue: item.maxTickets - (item.ticketsBought || 0),
          });
        }
      });
    }
    const selectedProducts = {
      id: event.currentTarget.id,
      title: event.target.value,
    };
    setSelectedValue({ ...selectedValue, selectedProduct: selectedProducts });
  };
  const handleWeeklySubscriptionProductChange = (event) => {
    const selectedProducts = {
      id: event.currentTarget.id,
      title: event.target.value,
      prizeId: event.currentTarget.dataset.id,
    };
    setSelectedValue({
      ...selectedValue,
      selectedWeeklySubscriptionProduct: selectedProducts,
    });
  };

  const saveTickets = async (): Promise<void> => {
    const data: AddTicketsData = {
      ticketsCount: selectedValue.ticketsCount,
      competition: getCompetitionName(selectedValue.competition),
      prizeId: selectedValue.selectedProduct.id,
      weeklySubscriptionCompetitionId:
        selectedValue.selectedWeeklySubscriptionProduct.id,
      weeklySubscriptionDrawId:
        selectedValue.competition === 'Weekly Subscription Draw'
          ? selectedValue.selectedWeeklySubscriptionProduct.prizeId
          : undefined,
    };
    try {
      setDisabledSaveButton(true);
      if (
        selectedValue.competition === 'Weekly Subscription Draw' &&
        !selectedValue.selectedWeeklySubscriptionProduct.id
      ) {
        notify(
          "Weekly Subscription Draw didn't selected or not found",
          'error'
        );
        setDisabledSaveButton(false);
        return;
      }
      const result = await dataProvider.addTickets(id, data);
      if (result.data) {
        setDisabledSaveButton(false);
        notify('Tickets added', 'info');
        closeModal();
        refresh();
      }
    } catch (error) {
      notify(error.data.error, 'error');
    }
  };

  const handleTicketsCount = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const count = parseInt(e.currentTarget.value);
    if (count < 1 || count > 5000) {
      return;
    }
    if (selectedValue.competition === 'Fixed Odds') {
      if (count > fixedOdds.maxValue) {
        return;
      }
    }
    setSelectedValue({ ...selectedValue, ticketsCount: count });
  };

  return (
    <>
      <Box padding='2em'>
        <Box display='flex' justifyContent='center' padding='1em'>
          <Typography variant='h6' className='base-color'>
            Add tickets
          </Typography>
        </Box>
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          padding='1em'
        >
          <Typography className='base-color'>Competition</Typography>
          <Select
            id='search-input'
            value={selectedValue.competition}
            onChange={handleChange}
            name='competition'
          >
            {competitions.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        {selectedValue.showCategory && (
          <>
            <Box
              display='flex'
              justifyContent='center'
              alignItems='center'
              padding='1em'
            >
              <Typography className='base-color'>Category</Typography>
              <Select
                id='search-input'
                value={categories.selectedCategory.title}
                onChange={handleCategoryChange}
                name={categories.selectedCategory.id}
              >
                {categories.category.length > 0 &&
                  categories.category.map((category) => {
                    return (
                      <MenuItem
                        key={category.id}
                        id={category.id}
                        value={category.title}
                      >
                        {category.title}
                      </MenuItem>
                    );
                  })}
              </Select>
            </Box>

            {categories.subCategory.length > 0 && (
              <Box
                display='flex'
                justifyContent='center'
                alignItems='center'
                padding='1em'
              >
                <Typography className='base-color'>Sub-category</Typography>
                <Select
                  id='search-input'
                  value={categories.selectedSubCategory.title}
                  onChange={handleSubCategoryChange}
                  name='subCategory'
                >
                  {categories.subCategory.map((subCategory) => {
                    return (
                      <MenuItem
                        key={subCategory._id}
                        id={subCategory._id}
                        value={subCategory.title}
                      >
                        {subCategory.title}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Box>
            )}
          </>
        )}
        {selectedValue.showWeeklySubscriptionDraws && (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            padding='1em'
          >
            <Typography className='base-color'>
              Weekly <br />
              Subscription Draw
            </Typography>
            <Select
              id='search-input'
              value={selectedValue.selectedWeeklySubscriptionProduct.id}
              onChange={handleWeeklySubscriptionProductChange}
              name='product'
            >
              {weeklySubscriptionDraws.length > 0 &&
                weeklySubscriptionDraws.map((product) => {
                  return (
                    <MenuItem
                      key={product.id}
                      id={product.id}
                      value={product.id}
                      data-id={product.weeklySubscriptionDraw._id}
                    >
                      <div className='select-product'>
                        {!product.isActive ? (
                          <>
                            <span className='closed-bage'>{`(${moment(
                              product.startAt
                            ).format('DD.MM')}-${moment(product.endsAt).format(
                              'DD.MM'
                            )})`}</span>
                            <span className='closed-bage'>Closed</span>
                          </>
                        ) : (
                          <>
                            <span className='active-bage'>{`(${moment(
                              product.startAt
                            ).format('DD.MM')}-${moment(product.endsAt).format(
                              'DD.MM'
                            )})`}</span>
                            <span className='active-bage'>Active </span>
                          </>
                        )}
                        {product.competitionId}{' '}
                        {product.weeklySubscriptionDraw
                          ? product.weeklySubscriptionDraw.title
                          : 'Weekly Subscription Draw'}
                      </div>
                    </MenuItem>
                  );
                })}
            </Select>
          </Box>
        )}
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          padding='1em'
        >
          <Typography className='base-color'>Product</Typography>
          <Select
            id='search-input'
            value={selectedValue.selectedProduct.id}
            onChange={handleProductChange}
            name='product'
          >
            {products.length > 0 &&
              products.map((product) => {
                return (
                  <MenuItem key={product.id} id={product.id} value={product.id}>
                    <div className='select-product'>
                      {' '}
                      {!product.active && product.isClosed ? (
                        <span className='closed-bage'>Closed </span>
                      ) : (
                        <span className='active-bage'>Active</span>
                      )}
                      {product.title ? product.title : product.title}
                    </div>
                  </MenuItem>
                );
              })}
          </Select>
        </Box>
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          padding='1em'
        >
          <Typography className='base-color'>Tickets</Typography>
          <TextField
            type='number'
            label=''
            className='add-tickets-field'
            value={selectedValue.ticketsCount}
            inputProps={{ step: 1 }}
            onChange={handleTicketsCount}
            defaultValue={1}
            required
          />
        </Box>
        <Box display='flex' justifyContent='space-evenly' paddingTop='1em'>
          <Button
            className='user-cancel-button user-modal-buttons'
            disabled={
              selectedValue.ticketsCount ? false : true || disabledSaveButton
            }
            onClick={saveTickets}
          >
            Save
          </Button>
          <Button
            className='user-cancel-button user-modal-buttons'
            onClick={closeModal}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AddTickets;
